// Screen teardown hook. Calls `fn` once `node` has been removed from the document — used by
// screens to clear intervals / outbox subscriptions / timers when the router swaps them out.
// One self-disconnecting MutationObserver per registration; `fn` runs at most once. Returns a
// disposer so a screen can also tear down explicitly (e.g. on finish/discard) before unmount.
export function onUnmount(node, fn) {
  let done = false;
  const run = () => {
    if (done) return;
    done = true;
    obs.disconnect();
    try {
      fn();
    } catch (e) {
      console.error("onUnmount handler failed", e);
    }
  };
  const obs = new MutationObserver(() => {
    if (!document.body.contains(node)) run();
  });
  // Observe after the node has had a chance to mount.
  setTimeout(() => {
    if (!document.body.contains(node)) run();
    else obs.observe(document.body, { childList: true, subtree: true });
  }, 0);
  return run;
}
